import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import clsx from 'clsx';
import React, { Fragment } from 'react';
import { TW_RING } from '../../../domain/websiteDomain';

interface SelectProps {
  label: string;
  options: { key?: any; label: string }[];
  onSelect: (key: any) => void;
  side: 'left' | 'right';
}

const Select: React.FC<SelectProps> = ({ label, options, onSelect, side }) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      {({ open }) => (
        <>
          <div>
            <Menu.Button
              className={clsx(
                'flex flex-row items-center justify-center w-full py-2 bg-white text-sm font-family-semibold text-gray-700 hover:text-accent-hover',
                TW_RING
              )}
            >
              <span className="mr-1">{label}</span>
              <ChevronDownIcon className="h-6 w-6" aria-hidden="true" />
            </Menu.Button>
          </div>

          <Transition
            show={open}
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              static
              className={clsx(
                'origin-top-right absolute mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10',
                side === 'right' && 'left-0',
                side === 'left' && 'right-0'
              )}
            >
              <div className="py-1">
                {options.map(option => (
                  <Menu.Item key={option.label}>
                    {({ active }) => (
                      <div
                        onClick={() => onSelect(option.key || option.label)}
                        className={clsx(
                          active
                            ? 'bg-gray-100 text-gray-900'
                            : 'text-gray-700',
                          'block px-4 py-2 text-sm cursor-pointer'
                        )}
                      >
                        {option.label}
                      </div>
                    )}
                  </Menu.Item>
                ))}
              </div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  );
};

export default Select;
